var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kindeditor"},[_c('input',{ref:"pictureFile",staticStyle:{"display":"none"},attrs:{"accept":".png,.jpg,.gif","type":"file"},on:{"change":_vm.pictureFileChange}}),_c('textarea',{attrs:{"id":_vm.id,"name":"content"}},[_vm._v(_vm._s(_vm.outContent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }